/**
 * @generated SignedSource<<80044f762e24a3c72cd565d6f2a1d230>>
 * @relayHash b72cf3608c2296d8742cc2d034a67447
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aab379e1b4e106b1f00f9a77723712322d4e0be2ac154397f505abf6ef1064d2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "aab379e1b4e106b1f00f9a77723712322d4e0be2ac154397f505abf6ef1064d2",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
